/* eslint-disable import/no-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import ImageLoader from 'react-render-image';

import { fg } from '@confluence/feature-gating';

export default function ReactRenderImage(props) {
	// Produce the image tag as is because there is no onLoad event in SSR
	// Also render image tag directly if the page was SSRed because react-render-image always render placeholder first.
	// This will make image flicker
	return props.src &&
		// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
		(process.env.REACT_SSR || window.__SSR_RENDERED__) &&
		fg('replace_react_render_image_with_image_tag') ? (
		<>{props.loaded}</>
	) : (
		<ImageLoader {...props} />
	);
}
